import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    constructor(
        private router: Router,
        private authService: AuthService
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const user = this.authService.user;
        if (user) {
            return true;
        }

        // alert("Not Logged in so redirecting");
        // not logged in so redirect to login page with the return url
        this.router.navigate(['/'], { queryParams: { destination: state.url }});

        return false;
    }
}
